import copy from 'copy-to-clipboard';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { TitleGenerator } from 'utils/TitleGenerator';
import ButtonShareMail from 'utils/buttons/ButtonShareMail';
import ButtonShareProperty from 'utils/buttons/ButtonShareProperty';
import ButtonShareWpp from 'utils/buttons/ButtonShareWpp';

const SharePropModal = ({ propToShare, setPropToShare, type }) => {
  const { branchOffices } = useSelector(state => state.branchOffice);
  const { realEstate } = useSelector(state => state.realEstate);

  const [branchOfficeId, setBranchOfficeId] = useState('');
  const [generatedLink, setGeneratedLink] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyToClipboard = () => {
    copy(generatedLink);
    setIsCopied(true);
  };

  const handleGenerateLink = () => {
    if (generatedLink) {
      window.open(generatedLink, '_blank');
      handleHideModal();
    }
  };

  const openWhatsApp = () => {
    const message = `🏡 ¡Encontré una propiedad en CABAPROP que podría interesarte!\n\n${generatedLink}`;
    const whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, '_blank');
  };

  const sendMail = () => {
    window.open(
      `mailto:?subject=CABAPROP%20-%20${propToShare.title}&body=Vi%20esta%20propiedad%20en%20CABAPROP%20que%20podría%20interesarte%0A%0A${generatedLink}`,
      '_blank'
    );
  };

  useEffect(() => {
    if (branchOfficeId && propToShare) {
      let url;

      if (type === 'project') {
        url = `${process.env.REACT_APP_CLIENT_DETAIL_PROJECT}${
          propToShare.id
        }/${TitleGenerator(propToShare.title)}?re=${
          realEstate.id
        }&of=${branchOfficeId}`;
      } else {
        url = `${process.env.REACT_APP_CLIENT_DETAIL}${
          propToShare.id
        }/${TitleGenerator(propToShare.title)}?re=${
          realEstate.id
        }&of=${branchOfficeId}`;
      }

      setGeneratedLink(url);
    }
  }, [branchOfficeId, propToShare, realEstate, type]);

  useEffect(() => {
    let timeout;
    if (isCopied) {
      timeout = setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    }

    return () => clearTimeout(timeout);
  }, [isCopied]);

  const handleHideModal = () => {
    setPropToShare(null);
    setBranchOfficeId('');
    setGeneratedLink('');
  };

  return (
    <Modal show={!!propToShare} onHide={handleHideModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Compartir propiedad</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>
            Seleccionar Sucursal <span className="text-danger">*</span>
          </Form.Label>

          <Form.Select
            value={branchOfficeId}
            onChange={e => setBranchOfficeId(e.target.value)}
          >
            <option value="">Seleccionar Sucursal</option>
            {branchOffices.map(branchOffice => (
              <option key={branchOffice.id} value={branchOffice.id}>
                {branchOffice.branch_office_name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {generatedLink && (
          <Form.Group className="mb-3">
            <Form.Label>Enlace generado:</Form.Label>
            <Row>
              <Col xs={12} md={9}>
                <Form.Control type="text" value={generatedLink} readOnly />
              </Col>
              <Col md={3} className="d-none d-md-block">
                <button
                  className={`btn btn-primary w-100 ${
                    isCopied ? 'btn-success' : ''
                  }`}
                  onClick={handleCopyToClipboard}
                >
                  {isCopied ? 'Copiado' : 'Copiar'}
                </button>
              </Col>
            </Row>
            <Row className="d-block d-md-none mt-1">
              <Col xs={12}>
                <button
                  className={`btn btn-primary w-100 ${
                    isCopied ? 'btn-success' : ''
                  }`}
                  onClick={handleCopyToClipboard}
                >
                  {isCopied ? 'Copiado' : 'Copiar'}
                </button>
              </Col>
            </Row>
          </Form.Group>
        )}

        <div className="px-2">
          <Row>
            <Col xs={12} md={4} className="p-md-1">
              <ButtonShareProperty
                text="Abrir link"
                funcion={handleGenerateLink}
                disabled={!branchOfficeId}
                className="mb-2 mb-md-0 w-100"
              />
            </Col>
            <Col xs={12} md={4} className="p-md-1">
              <ButtonShareWpp
                text="Compartir"
                funcion={openWhatsApp}
                disabled={!branchOfficeId}
                className="mb-2 mb-md-0 w-100"
              />
            </Col>
            <Col xs={12} md={4} className="p-md-1">
              <ButtonShareMail
                text="Enviar"
                funcion={sendMail}
                disabled={!branchOfficeId}
                className="mb-2 mb-md-0 w-100"
              />
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};

SharePropModal.propTypes = {
  propToShare: PropTypes.object,
  setPropToShare: PropTypes.func.isRequired,
  branchOffices: PropTypes.array,
  type: PropTypes.oneOf(['project', 'property'])
};

export default SharePropModal;
